module.exports = __webpack_public_path__ + "img/1514507952.70f5d22e.jpg";